import React, { useState, useEffect } from "react";
import {
  searchPatients,
  getTemplate,
  savePatientInformation,
} from "../../services/Api";
import cogoToast from "cogo-toast";
import { SUCCESS_RESULT } from "../../Constants";
import { Spinner, Table } from "reactstrap";
import * as Survey from "survey-react";
import "survey-react/survey.css";
import { Button } from "reactstrap";
import * as browser from "react-device-detect";
import moment from "moment";
import { useHistory } from "react-router-dom";
const PatientRegistration = (props) => {
  const { room } = (props.location && props.location.state) || {};
  const history = useHistory();
  const [patients, setpatients] = useState([]);
  const [Isloading, setIsloading] = useState(false);
  const [phone, setphone] = useState("");
  const [template, settemplate] = useState(null);
  const [register_new, setRegister_new] = useState(false);
  const [show_register_button, setShow_register_button] = useState(false);
  const [Lat, setLat] = useState("");
  const [Lng, setLng] = useState("");

  const [started, setSaterted] = useState("");
  const [ended, setEnded] = useState("2");

  var model = null;
  useEffect(() => {
    getRegistrationTemplate();
    getLocation();

    setSaterted(moment(new Date()).format("YYYY-MM-DD HH:MM:SS"));

    return () => {};
  }, []);

  const getLocation = () => {
    if (!navigator.geolocation) {
      cogoToast.error("Geolocation is not supported by your browser ", {
        hideAfter: 5,
      });
    } else {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setLat(position.coords.latitude);
          setLng(position.coords.longitude);
        },
        () => {
          cogoToast.error("Unable to retrieve your location", {
            hideAfter: 5,
          });
        }
      );
    }
  };

  const _addVisit = (_patient) => {
    history.push({
      pathname: "/hmis/add-visit",
      state: {
        patient: _patient,
        room: room,
      },
    });
  };
  const _submit = (form_result) => {
    setEnded(moment(new Date()).format("YYYY-MM-DD HH:MM:SS"));
    var data = { beneficiary_details: {} };

    data.beneficiary_details = form_result.valuesHash;
    data.channel = 800;
    data.ip_address = "";
    data.location = {
      latitude: Lat,
      longitude: Lng,
    };

    data.imei = {
      OS: browser.browserName,
      manufacturer: "",
      model: "",
      brand: "",
      device: " - ",
      display: "",
      id: "32",
      version: browser.fullBrowserVersion,
    };

    data.version = "1";
    data.startedOn = started;
    data.endedOn = started;
    data.project_id = "900d4917-a5e9-4fd8-bd09-eea8463783cc";
    console.log(data);
    setIsloading(true);
    savePatientInformation(data)
      .then((res) => {
        setIsloading(false);
        var response = res.data;
        if (res.status == 200) {
          if (response.status == SUCCESS_RESULT) {
            console.clear();
            console.log(response);
            cogoToast.success("Patient Registered Successfully", {
              hideAfter: 5,
            });

            setRegister_new(false);
            finPatient();
          //  _addVisit(response.data.beneficiarymanagement_id);
          } else {
            cogoToast.error("Patient Registration Failed , pease try again ", {
              hideAfter: 5,
            });
          }
        }
      })
      .catch((err) => {
        setIsloading(false);
        console.log(err);
        cogoToast.error("Something went wrong, please Try again. ", {
          hideAfter: 5,
        });
      });
  };

  const getRegistrationTemplate = () => {
    setIsloading(true);

    getTemplate({ template_name: "patient-profile" })
      .then((res) => {
        console.log(res);
        setIsloading(false);

        if (res.status == 200) {
          var response = res.data;

          let tmp = response.data[0].template;
          settemplate(tmp);
          model = new Survey.Model(tmp);
          if (response.status == SUCCESS_RESULT) {
          } else {
            cogoToast.error(res.data.message, {
              hideAfter: 5,
            });
          }
        }
      })
      .catch((err) => {
        setIsloading(false);
        console.log(err);
        cogoToast.error("Something went wrong, please Try again. ", {
          hideAfter: 5,
        });
      });
  };
  const finPatient = () => {
    setIsloading(true);

    searchPatients(  {
      "search_phrase":phone,
      "search_type":"telephone"
 }  )
      .then((res) => {
        setIsloading(false);

        if (res.status == 200) {
          var response = res.data;
          if (response.status == SUCCESS_RESULT) {
            console.log(response.data);
            setpatients(response.data);
            if (response.data.length == 0) {
              setShow_register_button(true);
            } else {
              setRegister_new(false);
              setShow_register_button(false);
            }
          } else {
            cogoToast.error(res.data.message, {
              hideAfter: 5,
            });
          }
        }
      })
      .catch((err) => {
        setIsloading(false);
        console.log(err);
        cogoToast.error("Something went wrong, please Try again. ", {
          hideAfter: 5,
        });
      });
  };

  model = new Survey.Model(template);
  model.data = JSON.parse('{ "telephone": "' + phone + '" }');
  return (
    <>
    <div className="card" style={{width:"80%",margin:"auto"}}>
    <div className="card-body">
    
      <div className="row">
        <div className="col-md-12" >



 






     







        <h1 className="form-label">Search Patient</h1>
     
          <div className="input-group">
       
          <br/>
            <input
              type="text"
              placeholder="Search Phone Number"
              className="form-control search-input"
              autocomplete="off"
              onChange={(e) => setphone(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  finPatient();
                }
              }}
            />

<button className="btn search-button"  onClick={() => finPatient()} type="button"> FIND </button>
           
          </div>
        </div>
        <div className="col-md-5"></div>
        <div className="col-md-3"></div>
    

    
   
      <br/>
        {patients.length > 0 && (
          <Table className="table table-blue">
            <thead>
              <tr className="">
                <th>Patient Name</th>
                <th>Age</th>
                <th>Phone</th>

                <th>Actions</th>
              </tr>
            </thead>
            {patients?.map((patient, i) => {
              //let patient = JSON.parse(p.beneficiary_details);

              return (
                <tbody>
                  <tr
                    key={i}
                    className="col-md-6 col-xl-4"
                 
                  >
                    <td>
                      <span className="align-middle fw-bold">
                        {" "}
                     
                        {patient?.name}
                      </span>
                    </td>
                    <td> {patient.age} </td>
                    <td> {patient.contact_telephone} </td>
                    <td>
                      <Button
                        color="relief-success"
                        onClick={(e) => _addVisit(patient)}
                      >
                        Add Visit
                      </Button>
                    </td>
                  </tr>
                </tbody>
              );
            })}
          </Table>
        )}
      </div>
      <br/>
      <div className="d-flex justify-content-center my-1">
        {Isloading && <Spinner />}
      </div>
      <br/>
      {show_register_button && (
        <div className="p-0">
          <h3>PATEIENT WITH TELEPHONE # {phone} was Not Found </h3>
          <br /> <br />
          <Button
            color="relief-primary"
            onClick={(e) => {
              setRegister_new(true);
              setShow_register_button(false);
            }}
          >
            Register New Patient
          </Button>
        </div>
      )}

      {register_new && template != null && (
        <Survey.Survey model={model} onComplete={(data) => _submit(data)} />
      )}
        </div>
        </div>
    </>
  );
};

export default PatientRegistration;
